<template>
  <div>
    <v-layout justify-center>
      <v-flex>
        <v-card ref="form">
          <v-toolbar color="primary" dark>
            <v-toolbar-title>
              <span v-if="!!id">Изменить члена диссертационного совета</span>
              <span v-else> <div>Создать члена диссертационного совета</div></span>
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-items>
              <v-toolbar-items>
                <v-btn @click="closeDialog" class="pa-0 ma-0" dark flat icon>
                  <v-icon>close</v-icon>
                </v-btn>
              </v-toolbar-items>
            </v-toolbar-items>
          </v-toolbar>
          <v-card-text>

            <v-autocomplete
              :error="hasError('dissertationCouncil')"
              :error-messages="getError('dissertationCouncil')"
              :items="selectors.dissertationCouncil"
              label="Диссертационный совет"
              v-model="value.dissertationCouncil"
              no-data-text ="Нет данных"
            ></v-autocomplete>

            <v-autocomplete
              :error="hasError('scientificField')"
              :error-messages="getError('scientificField')"
              :items="selectors.scientificField"
              label="Научная специальность (по отраслям науки) предстваляемая в диссертационном совете"
              v-model="value.scientificField"
              no-data-text ="Нет данных"
            ></v-autocomplete>

            <v-autocomplete
              :error="hasError('person')"
              :error-messages="getError('person')"
              :items="selectors.person"
              label="Лицо"
              v-model="value.person"
              no-data-text ="Нет данных"
            ></v-autocomplete>

            <v-text-field
              :error="hasError('email')"
              :error-messages="getError('email')"
              label="email"
              v-model="value.email"
            ></v-text-field>

            <v-text-field
              :error="hasError('researcherID')"
              :error-messages="getError('researcherID')"
              label="Researcher ID (Web of science)"
              placeholder="[A-Z]-0000-0000"
              v-model="value.researcherID"
              v-mask="mask"
            ></v-text-field>

            <v-text-field
              :error="hasError('scopusAutorID')"
              :error-messages="getError('scopusAutorID')"
              label="Autor ID (Scopus)"
              v-model="value.scopusAutorID"
              placeholder="0000000000"
              v-mask="mask1"
            ></v-text-field>

            <v-text-field
              :error="hasError('spin')"
              :error-messages="getError('spin')"
              label="SPIN (РИНЦ)"
              v-model="value.spin"
              placeholder="0000-0000"
              v-mask="mask2"
            ></v-text-field>

            <v-text-field
              :error="hasError('internationalPublications')"
              :error-messages="getError('internationalPublications')"
              label="Количество публикаций в международных базах данных"
              v-model="value.internationalPublications"
              v-mask="mask3"
            ></v-text-field>

            <v-text-field
              :error="hasError('peerReviewedJournalPublications')"
              :error-messages="getError('peerReviewedJournalPublications')"
              label="Количество публикаций в журналах из перечня рецензируемых научных изданий"
              v-model="value.peerReviewedJournalPublications"
              v-mask="mask3"
            ></v-text-field>

            <v-text-field
              :error="hasError('internationalEvents')"
              :error-messages="getError('internationalEvents')"
              label="Количество международных научных мероприятий"
              v-model="value.internationalEvents"
              v-mask="mask3"
            ></v-text-field>

            <v-text-field
              :error="hasError('localEvents')"
              :error-messages="getError('localEvents')"
              label="Количество всеросийских научных мероприятий"
              v-model="value.localEvents"
              v-mask="mask3"
            ></v-text-field>

            <v-checkbox
              v-model="value.scientificSecretary"
               label="Ученый секретарь"
            ></v-checkbox>

            <v-checkbox
              v-model="value.chairman"
              label="Председатель"
            ></v-checkbox>

            <v-checkbox
              v-model="value.viceChairman"
              label="Заместитель председателя"
            ></v-checkbox>

          </v-card-text>
          <v-divider class="mt-1"></v-divider>
          <v-alert
            :value="hasError('detail')"
            type="error"
          >
            {{getError('detail')}}
          </v-alert>
          <v-btn @click="apply" color="primary">Сохранить</v-btn>
        </v-card>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
    // import urls from "../../../../../urls"
    import UserDataFormMixin from '../../../../../mixins/UserDataFormMixin'
    import {makeGetRequest} from "../../../../../helper";
    import { mask } from 'vue-the-mask'

    export default {
        name: "Dissertation_council_member",
        mixins: [UserDataFormMixin],
        props:['id','info'],
        directives: {
            mask,
        },
        data() {
            return {
                mask: 'A-####-####',
                mask1: '##########',
                mask2: '####-####',
                mask3: '####',
                URL_CREATE: process.env.VUE_APP_API_HOST +"council/admin/diss/models/dissertation_council_member/",
                URL_UPDATE:  process.env.VUE_APP_API_HOST +"council/admin/diss/models/dissertation_council_member/<id>/",
                selectors:{
                    scientificField:[],
                    person:[],
                    dissertationCouncil:[],
                },

                value: {
                    id: this.id || '',
                    dissertationCouncil: null,
                    token: null,
                    email: null,
                    person: null,
                    scientificField: null,
                    researcherID: null,
                    scopusAutorID: null,
                    spin: null,
                    internationalPublications: null,
                    peerReviewedJournalPublications: null,
                    internationalEvents: null,
                    localEvents: null,
                    chairman: false,
                    viceChairman: false,
                    scientificSecretary: false,
                },
            }
        },
        watch: {
            $props: {
                handler() {
                    if(this.id){
                        let url =  this.URL_UPDATE.replace('<id>',this.value.id)
                        let sys = true
                        makeGetRequest(url).then(resp => {
                            if (!resp.ok) {
                                sys = false
                            }
                            return resp.json()
                        }) .then(json => {
                          this.value=json
                        })
                    }


                },
                deep: true,
                immediate: true,
            },
        },
        methods: {
            load: function (app, url) {
                if (url === null) {
                    app.loadingPage = true;
                    return;
                }
                makeGetRequest(url)
                    .then(resp => resp.json())
                    .then(json => {
                        let next_url = null;
                        if (json['next'] !== null)
                            next_url = url.split('?')[0] + '?' + json['next'].split('?')[1];
                        for (let i in json['results']) {
                            app.selectors.person.push(Object.assign({}, json['results'][i]));
                        }
                        app.load(app, next_url);
                    });
            },
            closeDialog() {
                this.$emit('ended', '')
            },
            loadSelector(data,url){
                let sys = true
                makeGetRequest(url).then(resp => {
                    if (!resp.ok) {
                        sys = false
                    }
                    return resp.json()
                }) .then(json => {
                    this.selectors[data] = json
                })
            },
        },
        created() {
            if(this.$props.info !== undefined)
                this.value.dissertationCouncil = this.$props.info
            let url =  process.env.VUE_APP_API_HOST +"council/admin/core/selectors/scientific_field/"
            this.loadSelector("scientificField",url)
            url =  process.env.VUE_APP_API_HOST +"council/admin/diss/selectors/dissertation_council/"
            this.loadSelector("dissertationCouncil",url)
            url =  process.env.VUE_APP_API_HOST +"council/admin/core/selectors/person/"
            this.load(this, url)
        }
    }

</script>

<style scoped>

</style>
